<style lang="scss" src='./ProvisioningStep5.scss' scoped ></style>
<template src="./ProvisioningStep5.html"></template>

<script>
import { mapMutations, mapState } from 'vuex';
import VueSlider from 'vue-slider-component';
import 'vue-slider-component/theme/antd.css';

export default {
  name: 'ProvisioningStep5',
  components: {
    VueSlider,
  },
  data() {
    return ({
      sensor: null,
      sensorDepth: 0,
      maxValue: null,
      uom: 'DEPTH',
      interval: 1
    });
  },

  computed: {
    ...mapState(['course']), 
  },

  methods: {
    async continue() {
      this.setProvisionPayload({ sensor_depth: this.sensorDepth });
      return true;
    },

    getValues(){
      if(this.course.measurement_system == "METRIC"){
        this.maxValue = 15;

        if(this.course.facility_type && this.course.facility_type.override_max_depth && this.course.facility_type.max_depth){
          this.maxValue = Math.round(this.course.facility_type.max_depth * 2.54);
        }

      }else{
        this.maxValue = 6;
        this.interval = 0.5;

        if(this.course.facility_type && this.course.facility_type.override_max_depth && this.course.facility_type.max_depth){
          this.maxValue = this.course.facility_type.max_depth;
        }
      }
    },

    getSuggestedDepth() {
      if(this.course && this.course.measurement_system && this.course.measurement_system == 'METRIC'){
        return '35 cm';
      }
      return '14\"';
    },
    ...mapMutations('SensorProvisioning', ['setCanBack', 'setCanContinue', 'setProvisionPayload']),
  },

  beforeCreate() {},

  created() {},

  activated() {
    this.setCanContinue(this.continue);
    this.setCanBack(null);
  },

  mounted() {
    this.sensor = this.$store.state.sensor;
    this.getValues();
  },
};
</script>
